import WSInternalEvent from '../utils/helpers/ws-internal-event';

const listeners = {};

const add = (element, eventName, ...restAttributes) => {
  let options = false;

  if (typeof restAttributes[restAttributes.length - 1] !== 'function') {
    options = restAttributes.pop();
  }

  // eslint-disable-next-line func-names
  const func = WSInternalEvent.bind(element, function (event) {
    restAttributes.forEach((callback) => {
      callback.call(this, event);
    });
  });

  element.addEventListener(eventName, func, options);

  listeners[eventName] = listeners[eventName] || [];
  const listener = {
    element,
    func,
    options,
    id: `${eventName}_${Date.now()}`,
  };

  listeners[eventName].push(listener);

  return listener.id;
};

const remove = (element, eventName) => {
  if (!listeners[eventName]) {
    return;
  }

  listeners[eventName] = listeners[eventName].filter((handler) => {
    if (element === handler.element) {
      element.removeEventListener(eventName, handler.func, handler.options);

      return false;
    }

    return true;
  });
};

const removeById = (element, eventName, id) => {
  if (!listeners[eventName]) return;
  listeners[eventName] = listeners[eventName].filter((handler) => {
    if (id !== handler.id) return true;

    element.removeEventListener(eventName, handler.func, handler.options);
    return false;
  });
};

const reset = () => {
  const events = Object.keys(listeners);
  events.forEach((eventName) => {
    listeners[eventName].forEach((handler) => {
      remove(handler.element, eventName);
    });
  });
};

export default {
  add,
  remove,
  reset,
  removeById,
};
